"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoolDistribution = exports.getNftTotalRaise = exports.isNFTSale = exports.isNFTPool = exports.isReferralSale = exports.getHardCap = exports.fPrice = exports.getTokenPriceUsd = exports.getPoolLinkPath = exports.getNextSaleDate = exports.getSaleRegisterStartEnd = exports.getSaleStartEnd = exports.isSaleSoldOut = exports.SALE_STATUS_LABELS = exports.getSaleStatus = void 0;
var axios_1 = __importDefault(require("axios"));
var dayjs_1 = __importDefault(require("dayjs"));
var launchpadConstants_1 = require("../../launchpadConstants");
var utils_1 = require("../../shared/utils");
var getSaleStatus_1 = require("../../pool/utils/getSaleStatus");
Object.defineProperty(exports, "getSaleStatus", { enumerable: true, get: function () { return getSaleStatus_1.getSaleStatus; } });
Object.defineProperty(exports, "SALE_STATUS_LABELS", { enumerable: true, get: function () { return getSaleStatus_1.SALE_STATUS_LABELS; } });
var soldOutTolerance = (0, utils_1.toWei)('0.1');
var isSaleSoldOut = function (sale) {
    if (sale.tokensForSale.eqn(0)) {
        return false;
    }
    if ((0, exports.isNFTSale)(sale)) {
        return sale.tokensSold.toString() === (0, utils_1.toEth)(sale.tokensForSale);
    }
    if (sale.isSoftCap) {
        return false;
    }
    return sale.tokensForSale.sub(sale.tokensSold).lte(soldOutTolerance);
};
exports.isSaleSoldOut = isSaleSoldOut;
var getSaleStartEnd = function (sale) { return ({
    start: (0, dayjs_1.default)(sale.startDate),
    end: (0, dayjs_1.default)(sale.startDate).add(sale.durationHours, 'hour'),
}); };
exports.getSaleStartEnd = getSaleStartEnd;
var getSaleRegisterStartEnd = function (sale) { return ({
    registerStart: sale.registerDate ? (0, dayjs_1.default)(sale.registerDate) : undefined,
    registerEnd: sale.registerDate
        ? (0, dayjs_1.default)(sale.registerDate).add(sale.registerDuration, 'hour')
        : undefined,
}); };
exports.getSaleRegisterStartEnd = getSaleRegisterStartEnd;
var getNextSaleDate = function (sale) {
    var _a = (0, exports.getSaleStartEnd)(sale), start = _a.start, end = _a.end;
    var _b = (0, exports.getSaleRegisterStartEnd)(sale), registerStart = _b.registerStart, registerEnd = _b.registerEnd;
    var fcfsStart = sale.fcfsDuration && end.subtract(sale.fcfsDuration, 'hour');
    var now = (0, dayjs_1.default)();
    if (registerStart && now.isBefore(registerStart)) {
        return registerStart;
    }
    if (registerEnd && now.isBefore(registerEnd)) {
        return registerEnd;
    }
    if (now.isBefore(start)) {
        return start.add(30, 'second');
    }
    if (fcfsStart && now.isBefore(fcfsStart)) {
        return fcfsStart;
    }
    if (now.isBefore(end)) {
        return end;
    }
    return null;
};
exports.getNextSaleDate = getNextSaleDate;
var getPoolLinkPath = function (pool) {
    return "/pool/".concat(encodeURIComponent(pool.id));
};
exports.getPoolLinkPath = getPoolLinkPath;
var getTokenPriceUsd = function (id) {
    if (id === void 0) { id = 'binancecoin'; }
    return axios_1.default
        .get("https://api.coingecko.com/api/v3/simple/price?ids=".concat(id, "&vs_currencies=usd"))
        .then(function (res) { return parseFloat(res.data[id]['usd']); })
        .catch(function (err) {
        console.error(err);
        return 0;
    });
};
exports.getTokenPriceUsd = getTokenPriceUsd;
var fPrice = function (v, fundToken) {
    var _a;
    var str = typeof v === 'string' ? v : (0, utils_1.fNum)(v);
    return !fundToken || ((_a = fundToken.price) === null || _a === void 0 ? void 0 : _a.usd) === 1
        ? "$".concat(str)
        : "".concat(str, " ").concat(fundToken.symbol);
};
exports.fPrice = fPrice;
var getHardCap = function (sale, fundToken) {
    if (sale.hardCap) {
        return sale.hardCap;
    }
    var format = function (v) {
        var _a;
        return !fundToken || ((_a = fundToken.price) === null || _a === void 0 ? void 0 : _a.usd) === 1
            ? "$".concat(v)
            : "".concat(v, " ").concat(fundToken.symbol);
    };
    if ((0, exports.isNFTSale)(sale)) {
        var total = sale.inventory.reduce(function (acc, item) { return acc.add(item.price.muln(item.supply)); }, launchpadConstants_1.ZERO_BN);
        return format((0, utils_1.fNum)(total));
    }
    if (!sale.rate || sale.tokensForSale.eq(launchpadConstants_1.ZERO_BN)) {
        return 'TBA';
    }
    if (sale.fixedUsdPrice) {
        return format((0, utils_1.fNum)(sale.tokensForSale.muln(sale.fixedUsdPrice), 0));
    }
    try {
        return format((0, utils_1.fNum)(sale.tokensForSale.divn(sale.rate), 0));
    }
    catch (e) {
        return '';
    }
};
exports.getHardCap = getHardCap;
var isReferralSale = function (sale) {
    return sale.type === 'referral';
};
exports.isReferralSale = isReferralSale;
var isNFTPool = function (pool) { return 'isNft' in pool; };
exports.isNFTPool = isNFTPool;
var isNFTSale = function (sale) {
    return 'inventory' in sale;
};
exports.isNFTSale = isNFTSale;
var getNftTotalRaise = function (sale) {
    return sale.inventory.reduce(function (acc, item) { return acc.add(item.price.muln(item.supply)); }, launchpadConstants_1.ZERO_BN);
};
exports.getNftTotalRaise = getNftTotalRaise;
var getPoolDistribution = function (pool, predicate) {
    return (Array.isArray(pool.distribution) ? pool.distribution : [pool.distribution]).find(predicate);
};
exports.getPoolDistribution = getPoolDistribution;
